import { DashboardPropertiesDialog as DashboardPropertiesDialogComponent } from "components";
import { useCallback } from "react";
import { updateDashboard } from "store/operations";
import { useDispatch, useSelector } from "react-redux";
import { getDashboard } from "store/operations";
import QueryService from "services/QueryService";

const DashboardPropertiesDialog = (props) => {
  const guuid = props.dashboard.guuid;  
  const widgets = props.dashboard.widgets.map((wid) => props.widgets[wid]);
  const dispatch = useDispatch();
  const save = useCallback(
      (changes) => {
          return dispatch(updateDashboard(guuid, changes));
      },
      [guuid, dispatch]
  );
  async function share(orgids) {
    const results = await QueryService.shareDashboard(props.dashboard.guuid, orgids);
    const { status, error } = results;
    // force fetch dashboard again to get updated dashboard state
    dispatch(getDashboard(props.dashboard.guuid, true)).catch((e) => {
      console.error(e);
    });
    return { status, error };
  }
  return (
    <DashboardPropertiesDialogComponent {...props} widgets={widgets} save={save} saveDuplicate={props.duplicateDashboard} share={share}/>
  );
};

export default DashboardPropertiesDialog;
